import { useCallback } from 'react';
import { compareShallowObject } from '../../utils/comparators.js';
import useComparableEffect from '../../utils/useComparableEffect.js';

function useCamera(getRenderer, cameraProps, trackModified) {
    const getCamera = useCallback(() => getRenderer().getActiveCamera(), [getRenderer]);
    useComparableEffect(() => {
        if (!cameraProps)
            return;
        const camera = getCamera();
        const mtime = camera.getMTime();
        // filter out any null props
        Object.keys(cameraProps).forEach((key) => {
            const name = key;
            if (!cameraProps[name]) {
                delete cameraProps[name];
            }
        });
        camera.set(cameraProps);
        // force-set focal point and direction of projection,
        // as setting the position changes the focal point and dop
        if (cameraProps.directionOfProjection) {
            camera.setDirectionOfProjection(...cameraProps.directionOfProjection);
        }
        if (cameraProps.focalPoint) {
            camera.setFocalPoint(...cameraProps.focalPoint);
        }
        // camera.set doesn't return whether a change occurred,
        // since setPosition/etc. don't return this flag.
        trackModified(mtime < camera.getMTime());
    }, [cameraProps], ([cur], [prev]) => compareShallowObject(cur, prev));
    return getCamera;
}

export { useCamera as default };
